import * as StoreTypes from "../DataTypes/storeTypes";
import * as ActionGenerics from "../../../Common/actionGenerics";
import * as ActionTypes from "../Actions/actionTypes";
import * as Common from "./common";
import { reducer as reduxFormReducer } from "redux-form";
import * as Stripe from "./stripe";

export const rootReducer = (
    state: StoreTypes.IStore,
    action: ActionGenerics.IAction<ActionTypes.Actions>
): StoreTypes.IStore => {
    return {
        initialSettings: state.initialSettings,
        common: Common.common(state.common, action, state.initialSettings),
        stripe: Stripe.stripe(state.stripe, action, state.initialSettings),
        stripeForm: reduxFormReducer(state.stripeForm, action),
    };
};

export const gridRootReducer = (state: StoreTypes.IStoreCustomFormGrid): StoreTypes.IStoreCustomFormGrid => {
    return {
        initialSettings: state.initialSettings,
    };
};
